import { useGame } from "../context/GameContext.jsx";

export function useLanguage() {
  const { state } = useGame();
  const lang = state.language;
  const t = (fr, en) => lang === "fr" ? fr : en;
  return { lang, t };
}
